var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.524.464a.5.5 0 0 1 .952 0l.983 3.027a.5.5 0 0 0 .476.346h3.184a.5.5 0 0 1 .293.904L8.837 6.613a.5.5 0 0 0-.182.559L9.64 10.2a.5.5 0 0 1-.77.559L6.295 8.887a.5.5 0 0 0-.588 0L3.13 10.76a.5.5 0 0 1-.769-.56l.984-3.027a.5.5 0 0 0-.182-.56L.588 4.743a.5.5 0 0 1 .293-.905h3.184a.5.5 0 0 0 .476-.346z"
})));
export default SvgStar;